import { default as TransLink } from './TransLink';
import { default as TransAnchor } from './TransAnchor';
import { default as Trans } from './Trans';
import { default as HTMLTrans } from './HTMLTrans';
import { default as translateRedux, localeMinimalRedux }  from './translateRedux';
import { default as withTranslationProvider } from './withTranslationProvider';
import { withTranslation, getDefaultLanguage, getLocalisedPath, isValidLanguage, isDefaultLanguage, getPrintboxLocale } from './TranslationHelper';

export { TransLink, TransAnchor, Trans, HTMLTrans, translateRedux, localeMinimalRedux, withTranslationProvider, withTranslation, getDefaultLanguage, getLocalisedPath, isValidLanguage, isDefaultLanguage, getPrintboxLocale };



// WEBPACK FOOTER //
// ./src/Common/Translations/index.js